import React, { ReactNode } from 'react';
import classNames from 'classnames';

export interface HintProps {
  children: ReactNode;
  className?: string;
  invalid?: boolean;
  id?: string;
  variant?: 'hint' | 'characterCount' | 'decorative';
}

const Hint = ({ children, className, invalid, id, variant = 'hint' }: HintProps): JSX.Element => {
  return (
    <span
      id={id}
      aria-live={variant === 'characterCount' ? 'polite' : undefined}
      aria-hidden={variant === 'decorative'}
      className={classNames('usa-hint', className, {
        'usa-character-count__message': variant === 'characterCount',
        'usa-character-count__message--invalid': variant === 'characterCount' && invalid,
      })}
    >
      {children}
    </span>
  );
};

export default Hint;
